import { render } from "./collapsed-menu.vue?vue&type=template&id=13e2fba6"
import script from "./collapsed-menu.vue?vue&type=script&lang=js"
export * from "./collapsed-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__